import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'ksInitials',
})
export class InitialsPipe implements PipeTransform {
  transform(
    name: string | null | undefined,
    options: { delimiter?: RegExp; max?: number } = {},
  ): string {
    if (!name?.trim()) return '';

    const { delimiter = /\s+/, max = 2 } = options;

    return name
      .trim()
      .split(delimiter)
      .filter(Boolean)
      .slice(0, max)
      .map((w) => w[0]!.toUpperCase())
      .join('');
  }
}
